import scrollbar from "../scrollbar";

const configuratorPage = () => {
    let $container = $('.configurator');
    let $options_count = $container.find('.options__inner .options-section').length;

    if($container.length > 0) {
        $('.options-section:not(.options-section--model-choose)').eq(0).addClass('active').find('.options-section__content').slideDown(function () {
            if($('.js-configurator-modules .options__module').length > 2) {
                scrollbar('.js-configurator-modules', '.modules-scroll_y');
            }
        });
    }

    /*if($options_count > 4 ){
        scrollbar('.js-scroll-options', '.options-scroll_y');
    }*/

    $(document).on('click', '.custom-checkbox', function (){
        $(this).toggleClass('active');
    })
};

export default configuratorPage;